import React from 'react';

function Instagram(props: object) {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.1667 2.00098H5.83342C3.53223 2.00098 1.66675 3.86646 1.66675 6.16764V14.501C1.66675 16.8022 3.53223 18.6676 5.83342 18.6676H14.1667C16.4679 18.6676 18.3334 16.8022 18.3334 14.501V6.16764C18.3334 3.86646 16.4679 2.00098 14.1667 2.00098Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3333 9.80924C13.4361 10.5028 13.3176 11.2111 12.9947 11.8334C12.6718 12.4557 12.1609 12.9604 11.5346 13.2756C10.9083 13.5908 10.1986 13.7006 9.50641 13.5892C8.81419 13.4778 8.17472 13.151 7.67895 12.6552C7.18318 12.1594 6.85636 11.52 6.74497 10.8277C6.63359 10.1355 6.74331 9.42581 7.05852 8.79955C7.37374 8.17328 7.87841 7.66235 8.50074 7.33944C9.12307 7.01652 9.83138 6.89806 10.5249 7.0009C11.2324 7.10581 11.8873 7.43546 12.393 7.94116C12.8987 8.44686 13.2283 9.1018 13.3333 9.80924Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5833 5.75098H14.5916"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Instagram;
